import { render } from "./ImageShow.vue?vue&type=template&id=c9d6621c&scoped=true"
import script from "./ImageShow.vue?vue&type=script&lang=js"
export * from "./ImageShow.vue?vue&type=script&lang=js"

import "./ImageShow.vue?vue&type=style&index=0&id=c9d6621c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9d6621c"],['__file',"src/components/h5/image/ImageShow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c9d6621c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c9d6621c', __exports__)) {
    api.reload('c9d6621c', __exports__)
  }
  
  module.hot.accept("./ImageShow.vue?vue&type=template&id=c9d6621c&scoped=true", () => {
    api.rerender('c9d6621c', render)
  })

}


export default __exports__